import { getEnv } from "@/utils";
import APIAbstract from "./apiAbstract";
import { AxiosResponse } from "axios";

export default class OrganizationsApi extends APIAbstract {
  constructor() {
    super({
      baseUrl: `${getEnv("treebalApiUrlOrganization", "notSet")}`,
      basePath: "api/v1/organization",
    });
  }

  get endpoint(): string {
    return this.options.basePath;
  }

  public uploadBanner(
    orgId: string,
    file: File,
    link?: string
  ): Promise<AxiosResponse> {
    const data = new FormData();
    data.append("file", file);
    if (link !== undefined && link !== null && link.trim() !== "") {
      data.append("link", link.trim());
    }
    return this.client.post(`${this.endpoint}/${orgId}/banner`, data, {
      headers: { "content-type": "multipart/form-data" },
    });
  }

  public updateBannerLink(
    orgId: string,
    link: string | undefined
  ): Promise<AxiosResponse> {
    return this.client.patch(`${this.endpoint}/${orgId}/banner/link`, {
      bannerLink: link ?? "",
    });
  }

  public deleteBanner(orgId: string): Promise<AxiosResponse> {
    return this.client.delete(`${this.endpoint}/${orgId}/banner`);
  }
}
